import axios from 'axios';

const createApiClient = (url, username, password) => {
    return axios.create({
        baseURL: `${url}/wp-json/wp/v2`,
        headers: {
            'Content-Type': 'application/json',
            // If username or password are empty, skip Authorization header
            ...(username && password
                ? { Authorization: `Basic ${btoa(`${username}:${password}`)}` }
                : {}),
        },
    });
};

export const getPosts = async (site) => {
    try {
        const client = createApiClient(site.url, site.username, site.password);
        const response = await client.get('/posts');
        return response.data;
    } catch (error) {
        console.error('Error fetching posts:', error);
        return [];
    }
};

export const createPost = async (site, post) => {
    try {
        const client = createApiClient(site.url, site.username, site.password);
        const response = await client.post('/posts', post);
        return response.data;
    } catch (error) {
        console.error('Error creating post:', error);
        return null;
    }
};

export const updatePost = async (site, postId, post) => {
    try {
        const client = createApiClient(site.url, site.username, site.password);
        const response = await client.put(`/posts/${postId}`, post);

        return {
            success: true,
            data: response.data,
            message: "Post updated successfully",
        };
    } catch (error) {
        console.error("Error updating post:", error);

        return {
            success: false,
            data: null,
            message: error.response?.data?.message || "Failed to update post",
        };
    }
};


export const deletePost = async (site, postId) => {
    try {
        const client = createApiClient(site.url, site.username, site.password);
        await client.delete(`/posts/${postId}`);
        return true;
    } catch (error) {
        console.error('Error deleting post:', error);
        return false;
    }
};
